import React, { useState } from 'react';
import Select from 'react-select';

const SelectComponent = ({borderRadius, options, css, value = "", name, placeholder,height, handleChange }) => {
  // Convert options into react-select format

  // State to store selected option
  const [selectedValue, setSelectedValue] = useState(
    options?.find((item) => item?.value === value) || null
  );


  // Custom styles to reduce dropdown width and padding
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight:height? height : '30px', // Reduce height
      padding: '0px',
      textAlign:"left !important",
      borderRadius:borderRadius ? borderRadius:"5px 0px 0px 5px",
      borderColor: state.isFocused ? 'black' : provided.borderColor, // Change focus border color to black
      boxShadow: state.isFocused ? '0 0 0 1px black' : provided.boxShadow, // Ensure outline is also black
      '&:hover': { borderColor: 'black' }, // Change hover border color to black
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      border:"none !important",
      padding: '2px',
      margin: '3px',
      width: '20px',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '4px',
      border:"none"
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px',
    }),
    menu: (provided) => ({
      ...provided,
     // overflowY:'scroll',
     //maxHeight: '200px', // Set max height for dropdown options
     
    }),
  };

  return (
    <div className={css}>
      <Select
        options={options}
        value={selectedValue}
        onChange={(selectedOption) => {
          setSelectedValue(selectedOption);
          handleChange(name,selectedOption?.value);
        }}
        name={name}
        placeholder={placeholder || ''}
        styles={customStyles}
        className="focus:outline-black text-left max-h-[200px] outline-black outline-1"
      />
    </div>
  );
};

export default SelectComponent;
